import { render, staticRenderFns } from "./FilesForm.vue?vue&type=template&id=25074a39&scoped=true&"
import script from "./FilesForm.vue?vue&type=script&lang=js&"
export * from "./FilesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25074a39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25074a39')) {
      api.createRecord('25074a39', component.options)
    } else {
      api.reload('25074a39', component.options)
    }
    module.hot.accept("./FilesForm.vue?vue&type=template&id=25074a39&scoped=true&", function () {
      api.rerender('25074a39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/clients/components/client-maintain-tabs/FilesForm.vue"
export default component.exports